import { React, useEffect, useState } from "react";
import axios from "axios";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import images from "../../../utilities/images/images";
import { isEmpty } from "../../../custom_utilities/custom_useful_functions";
import { url_272 } from "../../../custom_utilities/api_services";
import useAuthUtils from "../../../hooks/auth/useAuthUtils";
import uiActions from "../../../redux/ui/action";
import { setCurrentCuetSubject } from "../../../redux/cuet/CuetSlice";

const Cuet = (props) => {
  const { startLoading, finishLoading } = props;

  const { headers } = useAuthUtils();
  const dispatch = useDispatch();
  let history = useHistory();

  const currentCuetPracticeData = useSelector(
    (state) => state?.CuetSlice?.currentCuetPracticeData
  );

  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    getSubjects();
  }, [currentCuetPracticeData]);

  //subjectList
  const getSubjects = async () => {
    startLoading();
    try {
      const response = await axios.post(
        `${url_272}?practice_id=${currentCuetPracticeData?.id}`,
        {
          headers,
        }
      );
      console.log(response);
      if (response.data.status === 200) {
        finishLoading();

        setSubjects(response.data.data);
      }
    } catch (error) {
      // finishLoading();
      console.log(error);
    } finally {
      finishLoading();
    }
  };

  const backGroundColorFromBackend = (color_code) => {
    const colorCode = color_code ? color_code.split(",") : null;

    if (colorCode !== null) {
      return {
        background: `linear-gradient(277deg,${colorCode[0]}, ${colorCode[1]} 101.46%  )`,
      };
    } else {
      return {
        background: "#ffffff",
      };
    }
  };

  const redirectToTopics = (item) => {
    dispatch(setCurrentCuetSubject(item));
    history.push("/cuet-topics");
  };

  return (
    <>
      <div className="topicWiseWrapper">
        {!isEmpty(subjects)
          ? subjects.length
            ? subjects.map((elem, index) => {
                return (
                  <div
                    key={index}
                    className="topicBox"
                    style={backGroundColorFromBackend(elem.color_code)}
                    onClick={() => redirectToTopics(elem)}
                  >
                    <div className="topicNameImg">
                      <div className="img_wrp">
                        <img src={elem.icon} alt="icon" />
                      </div>
                      <h5>{elem.sub_name}</h5>
                    </div>
                    <div className="arrow">
                      <img src={images.new_m2_rgtArr_blk} alt="arrow" />
                    </div>
                  </div>
                );
              })
            : null
          : null}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
  };
};
const mapDipatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(mapStateToProps, mapDipatchToProps)(Cuet);
